module.exports = {
  __depends__: [
    require(155)
  ],
  __init__: [ 'bpmnRules' ],
  bpmnRules: [ 'type', require(33) ]
};
